import React from 'react';
import { Button } from './Button';
export const HowItWorksSection = () => {
  const checkoutUrl = 'https://www.neurotoned.com/offers/sPjut2p7/checkout?coupon_code=21OFFNEUROPROGRAMNEWMEMBERS';
  return <section className="bg-gradient-to-b from-teal-800 to-teal-900 text-white py-16" data-id="element-226">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-227">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center" data-id="element-228">
          How It Works
        </h2>
        <div className="grid md:grid-cols-2 gap-8 mb-10" data-id="element-229">
          <div className="bg-white bg-opacity-10 p-6 rounded-lg" data-id="element-230">
            <h3 className="text-xl font-bold mb-3" data-id="element-231">
              30 Days of Guided Somatic Reset
            </h3>
            <ul className="list-disc pl-6 space-y-2" data-id="element-232">
              <li data-id="element-233">Follow at your own pace</li>
              <li data-id="element-234">Every day includes a 10–20 minute guided practice</li>
            </ul>
          </div>
          <div className="bg-white bg-opacity-10 p-6 rounded-lg" data-id="element-235">
            <h3 className="text-xl font-bold mb-3" data-id="element-236">
              Lifetime Access to All Content
            </h3>
            <ul className="list-disc pl-6 space-y-2" data-id="element-237">
              <li data-id="element-238">Revisit your favorite tools any time</li>
            </ul>
          </div>
          <div className="bg-white bg-opacity-10 p-6 rounded-lg" data-id="element-239">
            <h3 className="text-xl font-bold mb-3" data-id="element-240">
              Evidence-Based, Therapist-Led
            </h3>
            <ul className="list-disc pl-6 space-y-2" data-id="element-241">
              <li data-id="element-242">Created by a Doctor of Behavioral Health & Somatic Expert</li>
            </ul>
          </div>
          <div className="bg-white bg-opacity-10 p-6 rounded-lg" data-id="element-243">
            <h3 className="text-xl font-bold mb-3" data-id="element-244">
              Bonus: Deep-Dive Video Lessons
            </h3>
            <ul className="list-disc pl-6 space-y-2" data-id="element-245">
              <li data-id="element-246">Learn how trauma wires the body and how to rewire it</li>
            </ul>
          </div>
        </div>
        <div className="flex justify-center" data-id="element-247">
          <Button link={checkoutUrl} data-id="element-248">Get Started Now ➔</Button>
        </div>
      </div>
    </section>;
};